<template>
  <ViewerLayoutRoot class="content-owner-layout" data-testid="content-owner-layout">
    <ContentOwnerTopBar />

    <div class="content-owner-layout__content">
      <ViewerContent />
      <MetadataSection />
    </div>

    <div class="content-owner-layout__tabs">
      <ContentOwnerTabs @addedComment="emit('addedComment')" />
    </div>
  </ViewerLayoutRoot>
</template>

<script setup lang="ts">
import ViewerContent from '@/modules/viewer/components/Content.vue';
import ContentOwnerTopBar from './ContentOwnerTopBar.vue';
import ContentOwnerTabs from './ContentOwnerTabs.vue';
import MetadataSection from '../../shared/MetadataSection.vue';

import ViewerLayoutRoot from '../../shared/ViewerLayoutRoot.vue';
const emit = defineEmits<{
  addedComment: [];
}>();
</script>

<style scoped>
.content-owner-layout__content {
  @apply flex flex-col min-w-0;
}

.content-owner-layout__tabs {
  @apply mt-2;
}
</style>
